import * as React from 'react';

export const Morning = function (props) {
  const { color } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" role="img" width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M22.5 15H1.5M19.5 18.75H4.5M6.1875 15C5.96062 14.1139 5.93934 13.1877 6.12528 12.2921C6.31121 11.3965 6.69945 10.5553 7.26031 9.83273C7.82116 9.11018 8.53979 8.52542 9.36127 8.12316C10.1827 7.72089 11.0853 7.51177 12 7.51177C12.9147 7.51177 13.8173 7.72089 14.6387 8.12316C15.4602 8.52542 16.1788 9.11018 16.7397 9.83273C17.3006 10.5553 17.6888 11.3965 17.8747 12.2921C18.0607 13.1877 18.0394 14.1139 17.8125 15M7.5 3.75L8.25 5.25M2.25 9L3.75 9.75M21.75 9L20.25 9.75M16.5 3.75L15.75 5.25"
        stroke={color || '#333333'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
